import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { UserProfile } from "../endpoints/auth/auth.type";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const extractAddress = (location: UserProfile["userLocation"] | undefined) => {
  if (!location) return ''
  
  let address = "";
  if (location?.street_number) {
    address += location.street_number;
  }
  if (location?.street_name) {
    address += " " + location.street_name + ",";
  }
  if (location?.street_name) {
    address += " " + location.city + ",";
  }
  if (location?.state) {
    address += " " + location.state + ",";
  }
  if (location?.country) {
    address += " " + location.country + ".";
  }
  return !!address ? address : '';
};